import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { types, getRoot } from 'mobx-state-tree';
export const PropertyAmenityModel = types.model('PropertyAmenityModel', {
  id: types.optional(types.string, 'NEW_AMENITY'),
  commonAreaAmenityId: types.maybeNull(types.string),
  commonAreaAmenityOptionId: types.maybeNull(types.string),
  buildingIds: types.optional(types.array(types.string), [])
}).actions(store => {
  return {
    updateModel(payload) {
      Object.entries(payload).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        store[key] = value;
      });
    },
    updateModelValues(payload) {
      if (store.id === 'NEW_AMENITY') {
        store.updateModel(payload);
      } else {
        return;
      }
    }
  };
}).views(store => ({
  get amenityDetails() {
    const commonAreaAmenityItem = getRoot(store).homeDashboardStore.getCurrentCompany.commonAreaAmenities.find(i => i.id === store.commonAreaAmenityId);
    return _objectSpread(_objectSpread({}, store), {}, {
      name: commonAreaAmenityItem === null || commonAreaAmenityItem === void 0 ? void 0 : commonAreaAmenityItem.name,
      selectedOption: commonAreaAmenityItem === null || commonAreaAmenityItem === void 0 ? void 0 : commonAreaAmenityItem.commonAreaAmenityOptions.find(i => i.id === store.commonAreaAmenityOptionId),
      availableOptions: commonAreaAmenityItem === null || commonAreaAmenityItem === void 0 ? void 0 : commonAreaAmenityItem.commonAreaAmenityOptions
    });
  }
}));